import React, { useState } from "react";
import {
  Card,
  Stack,
  Group,
  Title,
  Collapse,
  UnstyledButton,
} from "@mantine/core";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";

function CollapsibleCard({ title, action, defaultOpen = true, children }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Card padding="lg" radius="md" withBorder>
      <Stack gap="sm">
        <Group justify="space-between" align="center">
          <UnstyledButton onClick={() => setOpen(o => !o)}>
            <Group gap="xs" align="center">
              {open ? (
                <IconChevronDown size={18} />
              ) : (
                <IconChevronRight size={18} />
              )}
              <Title order={5}>{title}</Title>
            </Group>
          </UnstyledButton>
          {action}
        </Group>
        <Collapse in={open}>{children}</Collapse>
      </Stack>
    </Card>
  );
}

export default CollapsibleCard;
